import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { downloadExportFile } from 'api/endpoints/Export';
import PropTypes from 'prop-types';

const DownloadModal = ({ show, onHide, record }) => {
  const handleDownload = async format => {
    try {
      toast.info(`Preparing ${format.toUpperCase()} file...`);

      const response = await downloadExportFile(record.id);

      if (response?.success && response.results?.url) {
        // Trigger download
        const link = document.createElement('a');
        // If the backend handles format conversion via URL param, append it
        const downloadUrl = response.results.url.includes('?')
          ? `${response.results.url}&format=${format}`
          : `${response.results.url}?format=${format}`;

        link.href = downloadUrl;
        link.setAttribute('download', record.file_name || 'export');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success(`Download started for ${format.toUpperCase()} format.`);
      } else {
        throw new Error('No download URL provided by server');
      }
    } catch (error) {
      console.error('Download error:', error);
      toast.error('Failed to download the file. Please try again.');
    } finally {
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="h5">Download Export File</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center py-4">
        <div className="mb-4">
          <i className="fas fa-file-download fa-3x text-success opacity-50 mb-3"></i>
          <p className="text-secondary">
            Please select your preferred format for the downloaded report:
          </p>
          <div className="small fw-bold text-dark mt-1">{record.file_name}</div>
        </div>
        <div className="d-flex flex-column gap-2 px-4">
          <Button
            variant="success"
            onClick={() => handleDownload('excel')}
            className="py-2 fw-bold"
          >
            <i className="fas fa-file-excel me-2"></i> Export as Excel
          </Button>
          <Button
            variant="primary"
            onClick={() => handleDownload('csv')}
            className="py-2 fw-bold"
          >
            <i className="fas fa-file-csv me-2"></i> Export as CSV
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer className="bg-light">
        <Button variant="secondary" onClick={onHide} size="sm">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

DownloadModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  record: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    file_name: PropTypes.string
  }).isRequired
};

export default DownloadModal;
